"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment_1 = require("moment");
function state(state) {
    return state;
}
exports.state = state;
function numberCruises(state) {
    var offers = lodash_1.cloneDeep(priceModelOffers(state));
    offers = sortOffers(state.sortBy.code, offers);
    return offers.length;
}
exports.numberCruises = numberCruises;
function numberSpecialCruises(state) {
    return function (code, virtualRegionName) {
        return specialOffers(state)(code, virtualRegionName).length;
    };
}
exports.numberSpecialCruises = numberSpecialCruises;
function carolCampaign(state) {
    return state.carolCampaign;
}
exports.carolCampaign = carolCampaign;
function specialCampaigns(state) {
    return state.carolCampaign.specialOffers;
}
exports.specialCampaigns = specialCampaigns;
function specialHeaderImage(state) {
    return function (code) {
        var offer = lodash_1.find(state.carolCampaign.specialOffers, function (offer) {
            return offer.name === code;
        });
        return offer ? offer.headerImage : null;
    };
}
exports.specialHeaderImage = specialHeaderImage;
function specialTeaserImage(state) {
    return function (code) {
        var offer = lodash_1.find(state.carolCampaign.specialOffers, function (offer) {
            return offer.name === code;
        });
        return offer ? offer.teaserImage : null;
    };
}
exports.specialTeaserImage = specialTeaserImage;
function filters(state) {
    return state.filter;
}
exports.filters = filters;
function lowestPrice(state) {
    var offers = getOfferData(state.searchResults);
    offers = sortOffers('price', offers);
    return offers.length > 0 ? offers[0].price : 0;
}
exports.lowestPrice = lowestPrice;
function lowestPriceSO(state) {
    return function (code) {
        var offersSO = getOfferData(state.specialResults[code]);
        offersSO = sortOffers('price', offersSO);
        return offersSO.length > 0 ? offersSO[0].price : 0;
    };
}
exports.lowestPriceSO = lowestPriceSO;
function offers(state) {
    var offers = lodash_1.cloneDeep(priceModelOffers(state));
    offers = sortOffers(state.sortBy.code, offers);
    // console.log('offers', offers)
    return offers;
    //
    /* let startFrom = 0
    let end = state.paging.itemsPerPage
    if (state.paging.currentPage > 1) {
      startFrom = (state.paging.currentPage - 1) * state.paging.itemsPerPage
      end = state.paging.currentPage * state.paging.itemsPerPage
      if (end > offers.length) {
        end = offers.length + 1
      }
    }
    const offersPerPage = offers.slice(startFrom, end)
    return offersPerPage */
}
exports.offers = offers;
function routeOffers(state) {
    var offers = lodash_1.cloneDeep(priceModelRouteOffers(state));
    offers = sortRouteOffers(state.sortBy.code, offers);
    // console.log('offers', offers)
    return offers;
}
exports.routeOffers = routeOffers;
function specialOffers(state) {
    return function (code, virtualRegionName) {
        var campaign = lodash_1.find(state.carolCampaign.specialOffers, function (specialOffer) {
            return specialOffer.name === code;
        });
        if (!campaign)
            return;
        var filterRegions = [];
        if (virtualRegionName) {
            var virtualRegion = lodash_1.find(campaign.virtualRegions, function (virtualRegion) {
                return virtualRegion.name === virtualRegionName;
            });
            if (virtualRegion) {
                lodash_1.each(virtualRegion.regions, function (region) {
                    if (region.id === 'all') {
                        filterRegions.length = 0;
                        return false;
                    }
                    filterRegions.push(region.id);
                });
            }
        }
        var cruisesByApril = aprilCruises(state)[campaign.campaignId];
        if (!cruisesByApril)
            return [];
        var cruisesIds = lodash_1.map(cruisesByApril, function (cruise) {
            return cruise.cruiseID ? cruise.cruiseID : null;
        });
        var filteredAndExtendedByApril = lodash_1.compact(lodash_1.map(filteredRoutes(state), function (filteredRoute) {
            filteredRoute.cruises = lodash_1.filter(filteredRoute.cruises, function (cruise) {
                return cruise.cruiseID && cruisesIds.indexOf(cruise.cruiseID) !== -1;
            });
            filteredRoute.cruises = lodash_1.map(filteredRoute.cruises, function (cruise) {
                var cruiseData = lodash_1.find(cruisesByApril, function (aprilCruise) {
                    return cruise.cruiseID === aprilCruise.cruiseID;
                });
                cruise.aprilData = cruiseData;
                cruise.price = cruiseData.price / 2;
                return cruise;
            });
            return filteredRoute.cruises.length > 0 ? filteredRoute : null;
        }));
        return lodash_1.filter(filteredAndExtendedByApril, function (route) {
            if (!filterRegions.length)
                return true;
            return route.regionIDs.length > 0
                ? filterRegions.indexOf(route.regionIDs[0]) > -1
                : false;
        });
    };
}
exports.specialOffers = specialOffers;
function specialOffersCheapestPriceGroupedByVirtualRegion(state) {
    return function (code) {
        var groupedPrices = {};
        var campaign = lodash_1.find(state.carolCampaign.specialOffers, function (specialOffer) {
            return specialOffer.name === code;
        });
        lodash_1.each(campaign.virtualRegions, function (virtualRegion) {
            groupedPrices[virtualRegion.name] = null;
            var routes = specialOffers(state)(code, virtualRegion.name);
            lodash_1.each(routes, function (route) {
                lodash_1.each(route.cruises, function (cruise) {
                    if (groupedPrices[virtualRegion.name] === null ||
                        groupedPrices[virtualRegion.name] > cruise.price)
                        groupedPrices[virtualRegion.name] = cruise.price;
                });
            });
        });
        return groupedPrices;
    };
}
exports.specialOffersCheapestPriceGroupedByVirtualRegion = specialOffersCheapestPriceGroupedByVirtualRegion;
function durations(state) {
    return lodash_1.sortBy(state.availableDurations, 'id');
}
exports.durations = durations;
function airports(state) {
    var airportsFilter = [
        {
            id: 'NONE',
            name: 'Alle Flughäfen',
            shortName: 'Alle Flughäfen',
        },
    ];
    return lodash_1.concat(airportsFilter, lodash_1.sortBy(state.availableAirports, 'name'));
}
exports.airports = airports;
function regions(state) {
    var regionsFilter = [
        {
            id: 'NONE',
            name: 'Alle Regionen',
            shortName: 'Alle',
        },
    ];
    return lodash_1.concat(regionsFilter, lodash_1.sortBy(state.availableRegions, 'name'));
}
exports.regions = regions;
function ships(state) {
    var shipsFilter = [
        {
            id: 'NONE',
            name: 'Alle Schiffe',
            shortName: 'Alle',
        },
    ];
    return lodash_1.concat(shipsFilter, lodash_1.sortBy(state.availableShips, 'name'));
}
exports.ships = ships;
function sortOptions(state) {
    return state.sortBy;
}
exports.sortOptions = sortOptions;
function specialSortOptions(state) {
    return state.specialSortBy;
}
exports.specialSortOptions = specialSortOptions;
function selectedTravelDuration(state) {
    var durationsArray = durations(state);
    var duration = lodash_1.find(durationsArray, {
        id: state.filter.travelDuration,
    });
    if (duration) {
        return duration;
    }
    return {
        id: 9999,
        name: 'Reisedauer',
        shortName: 'Dauer',
        from: null,
        to: null,
    };
}
exports.selectedTravelDuration = selectedTravelDuration;
function selectedAirport(state) {
    var airportsArray = airports(state);
    var airport = lodash_1.find(airportsArray, {
        id: state.filter.airport,
    });
    if (airport) {
        return airport;
    }
    return {
        id: 'NONE',
        name: 'ab Flughafen',
        shortName: 'ab Flughafen',
    };
}
exports.selectedAirport = selectedAirport;
function selectedRegion(state) {
    var regionsArray = regions(state);
    var region = lodash_1.find(regionsArray, {
        id: state.filter.region,
    });
    if (region) {
        return region;
    }
    return {
        id: 'NONE',
        name: 'Region',
        shortName: 'Region',
    };
}
exports.selectedRegion = selectedRegion;
function selectedShip(state) {
    var shipsArray = ships(state);
    var ship = lodash_1.find(shipsArray, {
        id: state.filter.shipCode,
    });
    if (ship) {
        return ship;
    }
    return {
        id: 'NONE',
        name: 'Schiff',
        shortName: 'Schiff',
    };
}
exports.selectedShip = selectedShip;
function filteredRoutes(state) {
    var filteredResults = lodash_1.cloneDeep(state.searchResults);
    if (state.filter.airport && state.filter.airport !== 'NONE') {
        var flightResults_1 = [];
        lodash_1.each(filteredResults, function (route) {
            var cruises = lodash_1.filter(route.cruises, function (cruise) {
                return cruise.airports.indexOf(state.filter.airport) > -1;
            });
            if (cruises.length > 0) {
                route.cruises = cruises;
                flightResults_1 = lodash_1.concat(flightResults_1, route);
            }
        });
        filteredResults = flightResults_1;
    }
    if (state.filter.region && state.filter.region !== 'NONE') {
        filteredResults = lodash_1.filter(filteredResults, function (route) {
            return route.regionIDs.indexOf(state.filter.region) > -1;
        });
    }
    if (state.filter.travelDuration !== 9999) {
        var duration_1 = selectedTravelDuration(state);
        filteredResults = lodash_1.filter(filteredResults, function (route) {
            return route.duration <= duration_1.to && route.duration >= duration_1.from;
        });
    }
    if (state.filter.timeFrom && state.filter.timeTo) {
        filteredResults = lodash_1.filter(filteredResults, function (route) {
            var cruises = lodash_1.filter(route.cruises, function (cruise) {
                return moment_1.utc(cruise.start, 'DD.MM.YYYY').isBetween(state.filter.timeFrom, state.filter.timeTo, null, '[]');
            });
            if (cruises && cruises.length > 0) {
                route.cruises = cruises;
                return route;
            }
            else {
                return false;
            }
        });
    }
    if (state.filter.cruises && state.filter.cruises.length) {
        var cruises_1 = lodash_1.map(state.filter.cruises, function (cruise) {
            return cruise.cruise;
        });
        filteredResults = lodash_1.map(filteredResults, function (route) {
            if (!route.cruises.length)
                return false;
            route.cruises = lodash_1.filter(route.cruises, function (cruise) {
                return cruises_1.indexOf(cruise.cruiseID) !== -1;
            });
            return route.cruises.length ? route : false;
        });
    }
    filteredResults = lodash_1.compact(filteredResults);
    return filteredResults;
}
exports.filteredRoutes = filteredRoutes;
function aprilCruises(state) {
    return state.aprilCampaigns;
}
exports.aprilCruises = aprilCruises;
function priceModelOffers(state) {
    var viewOffers = getOfferData(filteredRoutes(state));
    // console.log('viewOffers', viewOffers, viewOffers.length)
    return viewOffers;
}
exports.priceModelOffers = priceModelOffers;
function priceModelRouteOffers(state) {
    var viewOffers = getRouteOfferData(filteredRoutes(state), state.config.priceGroups);
    // console.log('viewOffers', viewOffers, viewOffers.length)
    return viewOffers;
}
exports.priceModelRouteOffers = priceModelRouteOffers;
function currentPage(state) {
    return state.paging.currentPage;
}
exports.currentPage = currentPage;
function numberPages(state) {
    return Math.ceil(numberCruises(state) / state.paging.itemsPerPage);
}
exports.numberPages = numberPages;
// export everything compliant to the vuex specification for getters
exports.default = {
    state: state,
    aprilCruises: aprilCruises,
    carolCampaign: carolCampaign,
    filters: filters,
    lowestPrice: lowestPrice,
    lowestPriceSO: lowestPriceSO,
    offers: offers,
    routeOffers: routeOffers,
    specialOffers: specialOffers,
    specialCampaigns: specialCampaigns,
    specialHeaderImage: specialHeaderImage,
    specialTeaserImage: specialTeaserImage,
    airports: airports,
    durations: durations,
    regions: regions,
    ships: ships,
    sortOptions: sortOptions,
    specialSortOptions: specialSortOptions,
    selectedAirport: selectedAirport,
    selectedTravelDuration: selectedTravelDuration,
    selectedRegion: selectedRegion,
    selectedShip: selectedShip,
    filteredRoutes: filteredRoutes,
    priceModelOffers: priceModelOffers,
    numberCruises: numberCruises,
    numberSpecialCruises: numberSpecialCruises,
    currentPage: currentPage,
    numberPages: numberPages,
    specialOffersCheapestPriceGroupedByVirtualRegion: specialOffersCheapestPriceGroupedByVirtualRegion,
};
function getRouteOfferData(routes, priceGroups) {
    var countCruises = 0;
    var results2 = [];
    priceGroups = lodash_1.concat(priceGroups, 99999);
    lodash_1.each(priceGroups, function (priceGroup) {
        var group = {
            priceGroup: priceGroup,
            routeOffers: [],
        };
        results2 = lodash_1.concat(results2, group);
    });
    lodash_1.each(routes, function (route) {
        var cheapestCruise = lodash_1.sortBy(route.cruises, ['price'])[0];
        var mapped = {
            cruiseId: cheapestCruise.cruiseID,
            priceModel: cheapestCruise.priceModel,
            price: cheapestCruise.price / 2,
            routeName: route.name,
            duration: route.duration,
            flightIncluded: cheapestCruise.flight,
            startDate: cheapestCruise.start,
            amenities: cheapestCruise.priceInfo.surcharges.length
                ? cheapestCruise.priceInfo.surcharges
                : null,
        };
        lodash_1.each(priceGroups, function (priceGroup) {
            if (mapped.price <= priceGroup) {
                var group = lodash_1.find(results2, { priceGroup: priceGroup });
                group.routeOffers = lodash_1.concat(group.routeOffers, mapped);
                return false;
            }
        });
        // console.log('results2', JSON.stringify(results2))
    });
    return results2;
}
function getOfferData(routes) {
    var countCruises = 0;
    var results = [];
    lodash_1.each(routes, function (route) {
        var mapped = lodash_1.map(route.cruises, function (cruise) {
            return {
                cruiseId: cruise.cruiseID,
                amenity: cruise.priceInfo.surcharges.length
                    ? cruise.priceInfo.surcharges
                    : null,
                priceModel: cruise.priceModel,
                price: cruise.price / 2,
                cruiseName: route.name,
                germanDeparture: lodash_1.indexOf(['Kiel', 'Hamburg', 'Warnemünde', 'Bremerhaven'], route.startHabour) > -1
                    ? true
                    : false,
                germanArrival: lodash_1.indexOf(['Kiel', 'Hamburg', 'Warnemünde', 'Bremerhaven'], route.endHabour) > -1
                    ? true
                    : false,
                datesDisplay: cruise.datesDisplay,
                duration: route.duration,
                startPort: route.startHabour,
                ship: cruise.ship,
                start: cruise.start,
                flight: cruise.flight,
            };
        });
        results = lodash_1.concat(results, mapped);
        return mapped;
    });
    return results;
}
function sortOffers(code, offers) {
    switch (code) {
        case 'date':
            offers = lodash_1.sortBy(offers, function (offer) {
                return moment_1.utc(offer.start, 'DD.MM.YYYY');
            });
            break;
        case 'price':
        default:
            offers = lodash_1.sortBy(offers, function (offer) {
                return offer.price;
            });
    }
    return offers;
}
function sortRouteOffers(code, offers) {
    switch (code) {
        case 'date':
            lodash_1.each(offers, function (offer) {
                offer.routeOffers = lodash_1.sortBy(offer.routeOffers, function (offer) {
                    return moment_1.utc(offer.startDate, 'DD.MM.YYYY');
                });
            });
            break;
        case 'price':
        default:
            lodash_1.each(offers, function (offer) {
                offer.routeOffers = lodash_1.sortBy(offer.routeOffers, 'price');
            });
    }
    return offers;
}
function deepCopyObject(o) {
    var r, i, l;
    if (typeof o !== 'object')
        return o;
    if (!o)
        return o;
    if (o.constructor === Array) {
        r = [];
        l = o.length;
        for (i = 0; i < l; i++)
            r[i] = deepCopyObject(o[i]);
        return r;
    }
    var rr = {};
    for (i in o)
        rr[i] = deepCopyObject(o[i]);
    return rr;
}
//# sourceMappingURL=getters.js.map